import React, { useEffect, useState } from "react";
import API from "../../Services/Dashboard";
import { toast } from "react-toastify";
import AddWaiver from "../../Pages/Waiver/AddWaiver";
import WaiverForm from "../../Pages/WaiverForm";
import Swal from 'sweetalert2'

const ComboProductModal = ({ comboProductStatus, comboProduct, onClose, cardDetails }) => {
    const [showComboModal, setShowComboModal] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [comboData, setComboData] = useState([]);
    const [countdown, setCountdown] = useState(0);
    const [message, setMessage] = useState("");
    const [showWaiver, setShowWaiver] = useState(false);
    const [WaiverLength, setWaiverLength] = useState([])

    useEffect(() => {
        setShowComboModal(comboProductStatus);
        setComboData(comboProduct);
        console.log('comboProduct', comboProduct.length);
        console.log('cardDetails', cardDetails);
    }, [comboProductStatus, cardDetails, comboProduct]);

    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setTimeout(() => {
                setCountdown(prev => prev - 1);
            }, 1000);
        } else if (countdown === 0 && showMessage) {
            setShowMessage(false);
            window.location.reload();
            if (onClose) onClose();
        }
        return () => clearTimeout(timer);
    }, [countdown, showMessage]);

    const handleHomeClick = () => {
        setShowComboModal(false);
        if (onClose) onClose();
        window.location.reload();
    };

    const handleDeleteItem = (id) => {
        setComboData(prev => prev.filter(item => item.id !== id));
    };

    // const handelRedeemOrder = async () => {
    //     console.log('localStorage.getItem("isWaiverRequired")', localStorage.getItem("isWaiverRequired"))
    //     const card_no = cardDetails[0].card_no;
    //     const productIds = comboData.map(item => item.id);
    //     console.log("..........", productIds)

    //     if (productIds.length === 0) {
    //         toast.warn("No combo products selected to redeem.");
    //         return;
    //     }
    //     const payload = { product_id: productIds };
    //     console.log("payload...", payload?.product_id?.length)
    //     setWaiverLength(payload?.product_id?.length)
    //     try {
    //         const response = await API.redeemOrder(card_no, payload);

    //         if (response.status === 200) {
    //             setMessage(response.data.message);

    //             if (localStorage.getItem("isWaiverRequired") === "true") {
    //                 setShowWaiver(true);
    //             } else {
    //                 setShowMessage(true);
    //                 setCountdown(5);
    //             }

    //             setShowComboModal(false);

    //         } else {
    //             toast.error(response.data.message || "Something went wrong.");
    //         }

    //     } catch (error) {
    //         if (error?.response?.status === 403) {
    //             window.location.replace("/Login")

    //         } else {
    //             toast.error("Failed to redeem. Please try again.");
    //         }
    //     }
    // };

    const handelRedeemOrder = async () => {
        console.log(
            'localStorage.getItem("isWaiverRequired")',
            localStorage.getItem("isWaiverRequired")
        );
        const card_no = cardDetails[0].card_no;
        const productIds = comboData.map((item) => item.id);
        // console.log("comboo", comboData)
        // console.log("..........", productIds);
        const productNames = comboData.map(item => item.name).join(", ");
        if (productIds.length === 0) {
            toast.warn("No combo products selected to redeem.");
            return;
        }
        const payload = { product_id: productIds };
        console.log("payload...", payload?.product_id?.length);
        setWaiverLength(payload?.product_id?.length);
        Swal.fire({
            title: "Are you sure?",
            text: `Do you really want to redeem this order for: ${productNames}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Redeem it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await API.redeemOrder(card_no, payload);
                    if (response.status === 200) {
                        setMessage(response.data.message);
                        Swal.fire("Success!", response.data.message, "success");
                        if (localStorage.getItem("isWaiverRequired") === "true" && cardDetails[0].party_id==null) {
                            setShowWaiver(true);
                        } else {
                            setShowMessage(true);
                            setCountdown(5);
                        }
                        setShowComboModal(false);
                    } else {
                        toast.error(response.data.message || "Something went wrong.");
                    }
                } catch (error) {
                    if (error?.response?.status === 403) {
                        window.location.replace("/Login");
                    } else {
                        toast.error("Failed to redeem. Please try again.");
                    }
                }
            }
        });
    };


    return (
        <div>
            {showComboModal && (
                <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content position-relative">
                            <button
                                className="btn btn-secondary position-absolute"
                                style={{ top: 10, right: 10 }}
                                onClick={handleHomeClick}
                            >
                                Back
                            </button>
                            <div className="modal-body my-5">
                                <div className="row justify-content-center mt-3">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h6><strong>Name:</strong> {cardDetails[0]?.customer_name}</h6>
                                        {/* <h6><strong>Available Point:</strong> {cardDetails[0]?.play_points}</h6> */}
                                    </div>
                                    <table className="table table-bordered text-center">
                                        <thead>
                                            <tr>
                                                <th style={{ backgroundColor: "#4D1C8D", color: "#fff" }}>Sr No</th>
                                                <th style={{ backgroundColor: "#4D1C8D", color: "#fff" }}>Item Name</th>
                                                {/* <th style={{ backgroundColor: "#4D1C8D", color: "#fff" }}>Quantity</th> */}
                                                <th style={{ backgroundColor: "#4D1C8D", color: "#fff" }}>Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {comboData.length > 0 ? (
                                                comboData.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.name}</td>
                                                        {/* <td>{item.qty}</td> */}
                                                        <td>
                                                            {index > 0 ? <button
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => handleDeleteItem(item.id)}
                                                            >
                                                                <i className="fa fa-trash-o"></i>
                                                            </button> : ""}

                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4">No combo products found.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                    {comboData.length > 0 && (
                                        <div className="d-flex justify-content-end mt-4">
                                            <div style={{ width: "40%" }}>
                                                <button
                                                    className="btn btn-success form-control"
                                                    style={{ borderRadius: '10px' }}
                                                    onClick={handelRedeemOrder}
                                                >
                                                    Redeem Now
                                                </button>
                                            </div>
                                        </div>


                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showMessage && (
                <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Redemption Status</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowMessage(false)}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <h5 className="text-enter">{message}</h5>
                                <p className="text-center">Closing in {countdown} second(s)...</p>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" onClick={() => setShowMessage(false)}>
                                    Close Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showWaiver && (
                <WaiverForm Waiverlength={WaiverLength} />

            )}
        </div>
    );
};

export default ComboProductModal;

